import { Exclude, Expose, Transform, Type } from 'class-transformer';

export enum ChannelType {
  INSTAGRAM = 'instagram',
  PINTEREST = 'pinterest',
  TIKTOK = 'tiktok',
  FACEBOOK = 'facebook',
  TWITTER = 'twitter',
  LINKEDIN = 'linkedin',
  YOUTUBE = 'youtube'
}

@Exclude()
export class PlatformAccountDTO {
  @Expose()
  id: string;

  @Expose()
  username: string;

  @Expose()
  pic: string;

  @Expose()
  type: string;

  @Expose()
  isToggledAccount: boolean;

  get isInstagram(): boolean {
    return this.type === ChannelType.INSTAGRAM;
  }

  get isPinterest(): boolean {
    return this.type === ChannelType.PINTEREST;
  }

  get isTiktok(): boolean {
    return this.type === ChannelType.TIKTOK;
  }

  get isFacebook(): boolean {
    return this.type === ChannelType.FACEBOOK;
  }

  get isTwitter(): boolean {
    return this.type === ChannelType.TWITTER;
  }
}
